import { Link } from 'react-router-dom';
import AnimSection from '../components/AnimSection';
import { INDUSTRIES, FB_CHALLENGES } from '../data';

export default function Industries() {
  return (
    <div className="page-enter" style={{ paddingTop:'66px' }}>

      {/* ── PAGE HERO ─────────────────────────── */}
      <div style={{ background:'var(--page-hero-soft)', padding:'5rem clamp(1.2rem,4vw,3rem) 4rem', borderBottom:'1px solid var(--border-1)', position:'relative', overflow:'hidden' }}>
        <div className="grid-bg" style={{ position:'absolute', inset:0 }} />
        <div className="sw" style={{ position:'relative', zIndex:1 }}>
          <div className="tag" style={{ marginBottom:'1rem' }}>Sectors We Serve</div>
          <h1 className="section-title" style={{ fontSize:'clamp(2.4rem,5vw,4rem)', marginBottom:'1rem' }}>INDUSTRIES <span className="highlight">WE SERVE</span></h1>
          <p style={{ color:'var(--mu)', maxWidth:'600px', lineHeight:1.8, fontSize:'1.05rem' }}>
            Elbot Automation is revolutionising industries with cutting-edge automation solutions — providing innovative and reliable systems designed to meet the unique challenges of each sector.
          </p>
        </div>
      </div>

      {/* ── INDUSTRY CARDS ────────────────────── */}
      <div style={{ background:'var(--w3)', padding:'5rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {INDUSTRIES.map((ind,i) => (
              <AnimSection key={i} delay={i*.07}>
                <div className="card" style={{ padding:'2.5rem', height:'100%' }}>
                  <div className="icon-circle" style={{ width:'60px', height:'60px', fontSize:'1.8rem', marginBottom:'1.3rem' }}>{ind.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.4rem', letterSpacing:'1px', marginBottom:'.7rem' }}>{ind.name}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.9rem', lineHeight:1.75, marginBottom:'1.2rem' }}>{ind.desc}</p>
                  <div style={{ display:'flex', flexDirection:'column', gap:'.4rem' }}>
                    {ind.stats.map(s => (
                      <div key={s} className="badge" style={{ background:'var(--oL)', color:'var(--o)', border:'1px solid var(--accent-20)', display:'inline-flex', fontSize:'.72rem', width:'fit-content' }}>✓ {s}</div>
                    ))}
                  </div>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

      {/* ── DEEP DIVE: FOOD & BEVERAGE ────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Industry Deep Dive</div>
            <h2 className="section-title">FOOD & <span className="highlight">BEVERAGE</span><br />AUTOMATION</h2>
            <div className="divider" />
            <p style={{ color:'var(--mu)', maxWidth:'640px', lineHeight:1.8 }}>
              Food and beverage automation involves automating various processes within the manufacturing sector. This industry is highly complex — requiring producers to manage inventory, packaging, pricing, and supply chain while adhering to safety regulations, environmental standards, and legal requirements.
            </p>
          </AnimSection>

          {/* Challenges */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1.2rem', marginBottom:'4rem' }}>
            {FB_CHALLENGES.map((c,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div className="card" style={{ padding:'1.8rem', height:'100%' }}>
                  <div style={{ fontSize:'1.8rem', marginBottom:'1rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.05rem', letterSpacing:'1px', color:'var(--o)', marginBottom:'.7rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.85rem', lineHeight:1.75 }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>

          {/* Benefits + Solutions */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'start' }}>
            <AnimSection>
              <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.8rem', letterSpacing:'1px', marginBottom:'1.5rem' }}>AUTOMATION <span className="highlight">BENEFITS</span></h3>
              {[
                { t:'Enhanced Production Speed',    d:'Robotic arms, conveyors, and automated packing machinery dramatically reduce production cycle times.' },
                { t:'Reliable Quality Control',     d:'Vision systems and AI inspection ensure consistent product quality at every stage of production.' },
                { t:'Lower Labour Costs',           d:'Automation handles repetitive tasks, reducing dependency on manual labour and associated costs.' },
                { t:'Minimised Downtime',           d:'Predictive maintenance prevents equipment failures before they cause production stoppages.' },
                { t:'Energy Efficiency',            d:'Smart systems optimise energy consumption across the entire production process.' },
                { t:'Enhanced Traceability',        d:'Full end-to-end material tracking from raw ingredients to finished packaged goods.' },
              ].map((b,i) => (
                <div key={i} className="check-feature">
                  <div className="check-icon">✓</div>
                  <div>
                    <div style={{ fontFamily:'var(--fH)', fontSize:'.95rem', letterSpacing:'1px', marginBottom:'.2rem' }}>{b.t}</div>
                    <div style={{ color:'var(--mu)', fontSize:'.83rem', lineHeight:1.65 }}>{b.d}</div>
                  </div>
                </div>
              ))}
            </AnimSection>

            <AnimSection delay={.15}>
              <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.8rem', letterSpacing:'1px', marginBottom:'1.5rem' }}>ELBOT <span className="highlight">SOLUTIONS</span></h3>
              {[
                { icon:'🖥️', t:'SCADA/HMI Integration',    d:'Full SCADA visibility into production lines, real-time process control, and seamless compliance reporting for food safety standards.' },
                { icon:'🤖', t:'Automation in Packaging',   d:'Robotic packaging cells with conveyor integration — handling portion control, labelling compliance, and sustainable packaging at high speed.' },
                { icon:'⚡', t:'Industrial Controls',       d:'Hygienic-design-rated panels with IP69K rating, CIP-compatible sensors, and washdown-proof cabling for demanding food environments.' },
                { icon:'🔧', t:'Predictive Maintenance',   d:'AI and IoT-driven maintenance scheduling that prevents unplanned downtime and maximises OEE across your production line.' },
              ].map((s,i) => (
                <div key={i} className="card" style={{ padding:'1.5rem', display:'flex', gap:'1rem', marginBottom:'1rem' }}>
                  <div className="icon-circle" style={{ width:'40px', height:'40px', fontSize:'1.1rem', flexShrink:0 }}>{s.icon}</div>
                  <div>
                    <div style={{ fontFamily:'var(--fH)', fontSize:'1rem', letterSpacing:'1.5px', marginBottom:'.3rem' }}>{s.t}</div>
                    <p style={{ color:'var(--mu)', fontSize:'.84rem', lineHeight:1.7 }}>{s.d}</p>
                  </div>
                </div>
              ))}
            </AnimSection>
          </div>
        </div>
      </div>

      {/* ── PHARMA DEEP DIVE ──────────────────── */}
      <div style={{ background:'var(--w3)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Industry Deep Dive</div>
            <h2 className="section-title">PHARMACEUTICAL <span className="highlight">AUTOMATION</span></h2>
            <div className="divider" />
            <p style={{ color:'var(--mu)', maxWidth:'640px', lineHeight:1.8 }}>
              The pharmaceutical industry is crucial for global health. Automation enhances efficiency, compliance, and drug development. Elbot Automation optimises manufacturing, research, and distribution — driving innovation and better healthcare outcomes worldwide.
            </p>
          </AnimSection>

          <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'1.5rem' }}>
            {[
              { icon:'🔬', t:'GMP Compliance', d:'All automation solutions are designed in accordance with Good Manufacturing Practice (GMP) guidelines, ensuring every process meets regulatory requirements.' },
              { icon:'📝', t:'Batch Traceability', d:'Complete electronic batch records and genealogy tracking from raw material to finished product — satisfying FDA 21 CFR Part 11 and EU Annex 11 requirements.' },
              { icon:'🧪', t:'Process Validation', d:'We assist with IQ, OQ, and PQ validation protocols — providing documented evidence that all systems operate consistently within defined parameters.' },
              { icon:'❄️', t:'Cold Chain Automation', d:'Automated temperature monitoring, controlled storage, and cold chain logistics integration for temperature-sensitive biologics and vaccines.' },
              { icon:'📦', t:'Serialisation & Labelling', d:'Track-and-trace serialisation systems that comply with DSCSA, EU FMD, and other global anti-counterfeiting regulations for pharmaceutical packaging.' },
              { icon:'🤖', t:'Cleanroom Robotics', d:'ISO 5–8 classified cleanroom-compatible robotic systems for aseptic filling, capping, and inspection without human contamination risk.' },
            ].map((c,i) => (
              <AnimSection key={i} delay={i*.07}>
                <div className="card" style={{ padding:'2rem', height:'100%' }}>
                  <div style={{ fontSize:'2rem', marginBottom:'1rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.1rem', letterSpacing:'1px', color:'var(--o)', marginBottom:'.7rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.88rem', lineHeight:1.75 }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>
        </div>
      </div>

      {/* ── DEEP DIVE: MANUFACTURING ──────────── */}
      <div style={{ background:'var(--w2)', padding:'6rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw">
          <AnimSection style={{ marginBottom:'3.5rem' }}>
            <div className="tag" style={{ marginBottom:'1rem' }}>Industry Deep Dive</div>
            <h2 className="section-title">MANUFACTURING <span className="highlight">AUTOMATION</span></h2>
            <div className="divider" />
            <p style={{ color:'var(--mu)', maxWidth:'640px', lineHeight:1.8 }}>
              Modern manufacturing demands precision, speed, and scalability. Elbot Automation delivers end-to-end solutions that transform your plant floor — from raw material handling to finished goods, integrating PLC, SCADA, and control panel systems for maximum efficiency and minimal downtime.
            </p>
          </AnimSection>

          {/* Challenges */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'1.2rem', marginBottom:'4rem' }}>
            {[
              { icon:'⏱️', t:'Downtime Reduction', d:'Unplanned stoppages cost manufacturers lakhs per hour. Automation with predictive maintenance keeps your lines running around the clock.' },
              { icon:'📊', t:'Production Visibility', d:'Real-time SCADA dashboards provide live OEE, throughput, and quality metrics — enabling data-driven decisions on the shop floor.' },
              { icon:'🔄', t:'Process Consistency', d:'PLC-controlled processes eliminate human variability, ensuring every cycle produces identical output with minimal scrap and rework.' },
              { icon:'📈', t:'Scalable Growth', d:'Modular automation architectures allow you to expand capacity by adding lines or integrating new equipment without redesigning your entire system.' },
            ].map((c,i) => (
              <AnimSection key={i} delay={i*.08}>
                <div className="card" style={{ padding:'1.8rem', height:'100%' }}>
                  <div style={{ fontSize:'1.8rem', marginBottom:'1rem' }}>{c.icon}</div>
                  <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.05rem', letterSpacing:'1px', color:'var(--o)', marginBottom:'.7rem' }}>{c.t}</h3>
                  <p style={{ color:'var(--mu)', fontSize:'.85rem', lineHeight:1.75 }}>{c.d}</p>
                </div>
              </AnimSection>
            ))}
          </div>

          {/* Benefits + Solutions */}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'start' }}>
            <AnimSection>
              <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.8rem', letterSpacing:'1px', marginBottom:'1.5rem' }}>AUTOMATION <span className="highlight">BENEFITS</span></h3>
              {[
                { t:'Higher Throughput',           d:'Automated production lines run faster and longer than manual operations, dramatically increasing daily output.' },
                { t:'Reduced Scrap & Rework',      d:'Precision control and real-time quality monitoring catch defects early, keeping scrap rates below 0.5%.' },
                { t:'Energy Optimisation',          d:'Smart energy management systems monitor and reduce consumption across motors, compressors, and HVAC — cutting costs by up to 30%.' },
                { t:'Worker Safety',                d:'Hazardous and repetitive tasks are handled by automated systems, reducing workplace injuries and improving ergonomics.' },
                { t:'Real-Time OEE Monitoring',     d:'Track availability, performance, and quality in real time — identifying bottlenecks and driving continuous improvement.' },
                { t:'Legacy Equipment Integration', d:'Retrofit older machines with modern PLCs, sensors, and communication protocols to extend their productive life.' },
              ].map((b,i) => (
                <div key={i} className="check-feature">
                  <div className="check-icon">✓</div>
                  <div>
                    <div style={{ fontFamily:'var(--fH)', fontSize:'.95rem', letterSpacing:'1px', marginBottom:'.2rem' }}>{b.t}</div>
                    <div style={{ color:'var(--mu)', fontSize:'.83rem', lineHeight:1.65 }}>{b.d}</div>
                  </div>
                </div>
              ))}
            </AnimSection>

            <AnimSection delay={.15}>
              <h3 style={{ fontFamily:'var(--fH)', fontSize:'1.8rem', letterSpacing:'1px', marginBottom:'1.5rem' }}>ELBOT <span className="highlight">SOLUTIONS</span></h3>
              {[
                { icon:'🖥️', t:'SCADA & HMI Systems',       d:'Centralised plant monitoring with real-time dashboards, alarm management, and historical trend analysis for complete operational visibility.' },
                { icon:'⚡', t:'Control Panel Design',       d:'Custom-engineered panels with PLC, VFD, and safety relay integration — designed, built, and certified in-house to industry standards.' },
                { icon:'🏭', t:'System Integration',         d:'Seamless integration of conveyors, robots, sensors, and ERP/MES systems into a unified, fully automated production ecosystem.' },
                { icon:'📊', t:'Energy Management',          d:'Real-time energy metering, load balancing, and consumption reporting — helping you meet ISO 50001 targets and reduce utility bills.' },
              ].map((s,i) => (
                <div key={i} className="card" style={{ padding:'1.5rem', display:'flex', gap:'1rem', marginBottom:'1rem' }}>
                  <div className="icon-circle" style={{ width:'40px', height:'40px', fontSize:'1.1rem', flexShrink:0 }}>{s.icon}</div>
                  <div>
                    <div style={{ fontFamily:'var(--fH)', fontSize:'1rem', letterSpacing:'1.5px', marginBottom:'.3rem' }}>{s.t}</div>
                    <p style={{ color:'var(--mu)', fontSize:'.84rem', lineHeight:1.7 }}>{s.d}</p>
                  </div>
                </div>
              ))}
            </AnimSection>
          </div>
        </div>
      </div>

      
      {/* <div style={{ background:'var(--o)', padding:'4rem clamp(1.2rem,4vw,3rem)' }}>
        <div className="sw" style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'2rem' }}>
          <div>
            <h2 style={{ fontFamily:'var(--fH)', fontSize:'clamp(1.8rem,3.5vw,2.8rem)', letterSpacing:'2px', color:'var(--white)', marginBottom:'.5rem' }}>IS YOUR INDUSTRY LISTED?</h2>
            <p style={{ color:'var(--white-70)' }}>We work across many more sectors. Tell us about your operation and we'll design the perfect solution.</p>
          </div>
          <Link to="/contact" className="btn-white">Discuss Your Project →</Link>
        </div>
      </div> */}

    </div>
  );
}
